import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "staff-new-page",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "スタッフ新規登録", -1)

import Toast from "primevue/toast";
import StaffNew from "./components/New/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(StaffNew)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})